import { _js } from '@ifixit/localize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/pro-solid-svg-icons/faList';
import { getIndexes, getSearchClient, PUBLIC_KEY, isProUser } from 'Guide/searchClient';
import { InstantSearch } from '@ifixit/ui/components/instant-search';
import deviceNavigator from 'Shared/device_navigator';

// Add type declaration for window.deviceNavigator
declare global {
   interface Window {
      deviceNavigator?: () => void;
   }
}

export default function InstantSearchHero(props: { prompt: string }) {
   const searchClient = getSearchClient();
   const indices = getIndexes();

   /* Translators: Prompting the user to search for the phrase %1 */
   const prompt = _js('Try "%1"', props.prompt);

   const heroText = _js('Explore a World of Repair');

   return (
      <div className="relative z-[1] px-4 sm:px-0">
         <h1 className="m-0 font-['Arial_Black',_'Arial_Bold',_Gadget,_sans-serif] leading-tight !text-white text-center sm:text-3xl lg:!text-5xl text-pretty">
            {heroText}
         </h1>

         <div className="mt-7 mb-2">
            <InstantSearch
               searchClient={searchClient}
               apiKey={PUBLIC_KEY}
               indices={indices}
               isProUser={isProUser()}
               placeholder={prompt}
               currency={App.userPreferredStoreCurrency}
               localeCode={App.userPreferredStoreLocale}
               storeCode={App.userPreferredStoreCode}
               inputProps={{
                  className: 'rounded-md',
               }}
               popoverProps={{
                  side: 'bottom',
                  avoidCollisions: false,
               }}
            />
         </div>

         <div className="grid justify-center gap-2">
            <p className="text-center font-medium text-white">{_js('or')}</p>
            <button
               className="flex items-center gap-1.5 rounded-md !border-1 border-white/40 !bg-white/15 px-4 py-1.5 text-white hover:bg-white/20"
               onClick={deviceNavigator}
            >
               <FontAwesomeIcon icon={faList} />
               {_js('Find Your Device')}
            </button>
         </div>
      </div>
   );
}
